











import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getFinishRecords, addFinishLearnRecord } from '@/api/api'
import PDFJS from 'pdfjs-dist'
import { TextLayerBuilder } from 'pdfjs-dist/web/pdf_viewer'
import 'pdfjs-dist/web/pdf_viewer.css'
PDFJS.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.js'

@Component
export default class styleDialog extends Vue {
  @Prop()
  file: any
  @Prop()
  dialogVisible: any
  styleDialog: boolean = false
  completeText: string = '学习完毕'
  videoType = ['mp4', 'avi']

  totalPage: any = []

  get isVideo() {
    return this.videoType.includes(this.file.type)
  }

  @Watch('dialogVisible')
  whenSHowStatusChange(nVal: boolean) {
    if (nVal && this.file.type === 'pdf') {
      this.transPDF()
    }

    this.styleDialog = nVal
    this.completeText = '学习完毕'
    if (nVal) {
      getFinishRecords({
        page: 1,
        size: 999
      }).then((res: any) => {
        if (res.data.code === 101) {
          const arr = res.data.result.records
          for (let i = 0, len = arr.length; i < len; i++) {
            if (arr[i].course_id === this.file.id) {
              this.completeText = '学习已完成,无需重复'
              break
            }
          }
        }
      })
    }
  }

  @Watch('styleDialog')
  whenStyleDialogChange(nVal: boolean) {
    if (!nVal) {
      this.$emit('completeLearn')
    }
    if (nVal) {
      let container = document.getElementById('container')!
      if (container) container.innerHTML = ''
    }
  }

  /**
   * 添加学习记录
   */
  completeLearn(): void {
    if (this.completeText === '学习完毕') {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      addFinishLearnRecord({ course_id: this.file.id }).then((res: any) => {
        loading.close()
        if (res.data.status === 200 && res.data.message === '成功') {
          this.$notify({
            title: '成功',
            message: '学习已完成',
            type: 'success'
          })
          this.styleDialog = false
        } else {
          this.$message(res.data.message)
        }
      })
    } else {
      this.styleDialog = false
    }
  }

  // 转换pdf
  async transPDF() {
    let url = this.file.url
    let pdf: any = await PDFJS.getDocument(url)
    for (let i = 1; i <= pdf.numPages; i++) {
      await this.renderPDF(pdf, i)
    }
  }
  // 渲染pdf
  async renderPDF(pdf: any, index: number) {
    let container = document.getElementById('container')!
    let page = await pdf.getPage(index)
    let scale = 4
    let viewport = page.getViewport(scale)
    let pageDiv = document.createElement('div')
    pageDiv.setAttribute('id', 'page-' + (page.pageIndex + 1))
    pageDiv.setAttribute('style', 'position: relative')
    container.appendChild(pageDiv)
    let canvas = document.createElement('canvas')
    pageDiv.appendChild(canvas)
    let context = canvas.getContext('2d')
    canvas.height = viewport.height
    canvas.width = viewport.width
    canvas.style.width = '100%'

    let renderContext = {
      canvasContext: context,
      viewport: viewport
    }

    page.render(renderContext)
  }
}
